import React, { Component } from "react";
import Stepper from "./stepper";
import Logo from "./logo";
import {
  and,
  compose,
  equals,
  filter,
  find,
  head,
  isEmpty,
  isNil,
  length,
  not,
  or,
  propEq
} from "ramda";
import { currentLocale } from "../locale";

class Layout extends Component {
  render() {
    const {
      steps,
      currentStep,
      stepForward,
      skipBack,
      stepPrevious,
      id,
      children,
      waiver,
      skipForward,
      isValid,
      addStep,
      errors,
      touched,
      values,
      role,
      noSticky,
      pathParticipants,
      loading,
      flashing,
      selected,
      validStep
    } = this.props;

    const activeStep = find(propEq("step", currentStep))(steps);

    let notValid;

    if (currentStep === 2 && isEmpty(role)) {
      notValid = true;
    } else {
      notValid = false;
    }

    //currentSTep === 1 validation\\
    if (
      currentStep === 1 &&
      waiver.contactInformation &&
      waiver.iceNumber &&
      touched.email &&
      touched.phoneNumber &&
      touched.icePhoneNumber &&
      head(values.phoneNumber) === `+` &&
      head(values.icePhoneNumber) === `+` &&
      !equals(values.phoneNumber, values.icePhoneNumber) &&
      isEmpty(errors)
    ) {
      this.props.setValid();
    } else if (
      currentStep === 1 &&
      !waiver.contactInformation &&
      waiver.iceNumber &&
      touched.icePhoneNumber &&
      head(values.icePhoneNumber) === `+` &&
      isEmpty(errors)
    ) {
      this.props.setValid();
    } else if (
      currentStep === 1 &&
      !waiver.iceNumber &&
      touched.email &&
      touched.phoneNumber &&
      head(values.phoneNumber) === `+` &&
      isEmpty(errors)
    ) {
      this.props.setValid();
    } else if (
      //checking to ensure phoneNumber && icePhoneNumber are not the same
      and(
        equals(values.phoneNumber, values.icePhoneNumber),
        or(waiver.contactInformation, waiver.iceNumber)
      )
    ) {
      //switched from and(contact, ice) => or(contact, ice)
      waiver.contactInformation
        ? (errors.phoneNumber = currentLocale.icePhoneNumberError)
        : (errors.icePhoneNumber = currentLocale.icePhoneNumberError);
    } else {
      notValid = true;
    }

    //currentStep === 3 validation\\
    if (
      currentStep === 3 &&
      Number(role) === 1 &&
      !waiver.contactInformation &&
      !waiver.iceNumber &&
      touched.name &&
      !errors.name
    ) {
      this.props.setValid();
    } else if (
      currentStep === 3 &&
      or(Number(role) === 2, Number(role) === 3) &&
      !waiver.contactInformation &&
      !waiver.iceNumber &&
      touched.name &&
      !errors.name &&
      or(touched.participants, touched.linkedParticipants) &&
      or(!errors.participants, !errors.linkedParticipants)
    ) {
      this.props.setValid();
    } else if (
      currentStep === 3 && Number(role) === 1 && waiver.birthday
        ? touched.name && touched.birthday && isEmpty(errors)
        : touched.name &&
          length(this.props.formikProps.values.name) > 2 &&
          isEmpty(errors)
    ) {
      this.props.setValid();
      ////referenceKey trial\\\\
    } else if (
      currentStep === 3 &&
      Number(role) === 1 &&
      !isEmpty(pathParticipants) &&
      waiver.birthday
        ? or(touched.id, touched.linkedParticipant) &&
          touched.birthday &&
          isEmpty(errors)
        : or(touched.id, touched.linkedParticipant) && isEmpty(errors)
    ) {
      this.props.setValid();
    } else if (
      currentStep === 3 && Number(role) === 2 && waiver.birthday
        ? touched.name &&
          touched.participants &&
          touched.participants.participantDateOfBirth &&
          touched.participants.participantName &&
          length(
            compose(
              filter(p => p.participantName),
              filter(p => p.participantDateOfBirth)
            )(touched.participants)
          ) === length(this.props.formikProps.values.participants) &&
          isEmpty(errors)
        : touched.name &&
          touched.participants &&
          touched.participants.participantName &&
          length(filter(p => p.participantName, touched.participants)) ===
            length(this.props.formikProps.values.participants) &&
          isEmpty(errors)
    ) {
      this.props.setValid();
    } else if (
      currentStep === 3 && Number(role) === 3 && waiver.birthday
        ? touched.name &&
          touched.birthday &&
          touched.participants &&
          touched.participants.participantDateOfBirth &&
          touched.participants.participantName &&
          length(
            compose(
              filter(p => p.participantName),
              filter(p => p.participantDateOfBirth)
            )(touched.participants)
          ) === length(this.props.formikProps.values.participants) &&
          isEmpty(errors)
        : touched.name &&
          touched.participants &&
          touched.participants.participantName &&
          length(filter(p => p.participantName, touched.participants)) ===
            this.props.formikProps.values.participants.length &&
          isEmpty(errors)
    ) {
      this.props.setValid();
    } else if (
      ////////no b-day linked system role 2\\\\\\
      currentStep === 3 &&
      Number(role) === 2 &&
      !isEmpty(pathParticipants) &&
      waiver.birthday
        ? touched.signedByName &&
          touched.linkedParticipants &&
          touched.linkedParticipants.participantDateOfBirth &&
          touched.linkedParticipants.participantDateOfBirth &&
          isEmpty(errors)
        : touched.signedByName &&
          !isNil(touched.linkedParticipants) &&
          touched.linkedParticipants.participantName &&
          length(filter(p => p.participantName, touched.linkedParticipants)) ===
            this.props.formikProps.values.linkedParticipants.length &&
          isEmpty(errors)
    ) {
      this.props.setValid();
    } else if (
      currentStep === 3 &&
      Number(role) === 3 &&
      !isEmpty(pathParticipants) &&
      waiver.birthday
        ? touched.signedByName &&
          touched.linkedParticipants &&
          touched.linkedParticipants.participantName &&
          touched.linkedParticipants.participantName &&
          touched.linkedParticipants.participantDateOfBirth &&
          touched.linkedParticipants.participantDateOfBirth &&
          isEmpty(errors)
        : touched.signedByName &&
          !isEmpty(touched.linkedParticipants) &&
          //touched.linkedParticipants.participantName &&
          isEmpty(errors)
    ) {
      this.props.setValid();
      /////////For errors after initially validate\\\\\\\
    } else if (
      currentStep === 1 &&
      (or(errors.email, errors.phoneNumber) || errors.icePhoneNumber)
    ) {
      this.props.setInvalid();
    } else if (currentStep === 3) {
      this.props.setInvalid();
      if (and(and(not(selected), not(validStep)), not(isEmpty(errors)))) {
        //stops nextButton flashing if step 3 was valid then they made changes that caused errors
        this.props.nextSelected();
      }
    }

    return (
      <div>
        <section className={currentStep === 0 ? "appBar show-logo" : "appBar"}>
          <Logo waiver={waiver} />
        </section>

        <br />
        {equals(waiver.waiverId, 0) ? (
          <div />
        ) : and(isNil(waiver.participantPdf), isNil(waiver.guardianPdf)) ? (
          <div />
        ) : (
          <div className="stepper-container">
            <Stepper
              steps={steps}
              currentStep={currentStep}
              activeStep={activeStep}
              stepForward={stepForward}
              waiver={waiver}
              skipForward={skipForward}
              skipBack={skipBack}
              addStep={addStep}
              stepPrevious={stepPrevious}
              onRoleChange={this.props.onRoleChange}
              validStep={this.props.validStep}
              validBackStep={this.props.validBackStep}
              marketingToAppState={this.props.marketingToAppState}
              ///added from formik
              signingInfo={this.props.signingInfo}
              isValid={isValid}
              notValid={notValid}
              formikProps={this.props.formikProps}
              submitWaiver={this.props.submitWaiver}
              opentok={this.props.opentok}
              recording={this.props.recording}
              handleReset={this.props.handleReset}
              handleSubmit={this.props.handleSubmit}
              pathParticipants={this.props.pathParticipants}
              requesting={this.props.recording}
              trim={this.props.trim}
              noSticky={noSticky}
              loading={loading}
              flashing={flashing}
              selected={this.props.selected}
              noneSelected={this.props.noneSelected}
              nextSelected={this.props.nextSelected}
              nextConfused={this.props.nextConfused}
            />
          </div>
        )}

        <div className="content-container">
          {id} {children}
        </div>
      </div>
    );
  }
}

export default Layout;
